<template>
    <select class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border border-gray-300 rounded-md px-4 py-2" :class="[{'bg-white':!disabled,'bg-gray-100':disabled},{'cursor-pointer':!disabled,'cursor-not-allowed':disabled}]" @input="$emit('update:modelValue', $event.target.value)" ref="input" :value="modelValue" :disabled="disabled">
        <slot name="options"></slot>
    </select>
</template>

<script>
    export default {
        props: ['modelValue','disabled'],

        emits: ['update:modelValue'],

        methods: {
            focus() {
                this.$refs.input.focus()
            }
        }
    }
</script>

